import { icons } from "assets"
import Back from "Components/main_components/registeration/Back"
import Button from "Components/shared/button"
import FormControl from "Components/shared/control"
import { InputWithAdornment } from "Components/shared/inputs"
import Select from "Components/shared/select"
import Text from "Components/shared/text"
import useForm from "hooks/useForm"
import React from "react"
import { useGetBeneficiaries } from "services/transferService"
import { useGetWalletBalance } from "services/walletService"
import { currencyMap } from "utils/constants/maps"
import { convertToCurrency } from "utils/stringServices"


import styles from '../transfer_components.module.css';

const SelectBeneficiary = ({onNext,onPrevious, ...props}) => {
    const {values, errors, touched, handleUpdate} = props;
    const {data:walletBal} = useGetWalletBalance();
   const {data: beneficiaries} = useGetBeneficiaries();

   const symbolMap = {
    Naira:"₦",
    Dollar: "$",
    Euro: "€"
   }
   
    return (
        <div className={styles.SelectBeneficiary}>
            {/* <Back onClick={onPrevious} /> */}
            <Text variant="lg" style={{fontWeight:700}}>Send money to saved beneficiary</Text>
            <div className={styles.Form}>
                {/* <FormControl label="Select account to debit" name="accountType" id='accountType' >
                    <Select options={[{currency:"₦", name:"Naira",balance:walletBal?.data?.ngn},
                    {currency:"$", name:"Dollar", balance:walletBal?.data?.usd }, {currency:"€", name:"Euro", balance:walletBal?.data?.eur}
                ]} optionsValue ={item => item.name}
                    
                     {...handleUpdate()}
                    
                    value={values.accountType || "Naira"}
                optionsText = {item => `${item.name} - ${convertToCurrency(item.balance)}`}
                 fullWidth />
                </FormControl> */}
                <FormControl label="Select beneficiary"  name="beneficiary" id="beneficiary" >
                    <Select 
                        placeholder="Select Beneficiary"
                        options={beneficiaries || []}
                        optionsText={item => `${item.accountName} - ${item.accountNumber} - ${item.bank}`}
                        optionsValue={item => item.beneficiaryId}
                        fullWidth
                        value={values.beneficiary}
                        
                        {...handleUpdate()}
                    />
                </FormControl>
                <FormControl label="To account" >
                    <InputWithAdornment value={
                        beneficiaries?.find(item => item.beneficiaryId == values.beneficiary)?.accountNumber || "" 
                    } readonly disabled fullWidth />
                </FormControl>
                <FormControl label="Amount" name="amount" id="amount" >
                    <InputWithAdornment onInput={(e) => {

                let matching = ``;
                console.log(matching);
                if(!e.target.value.match(/^[$₦€]?[0-9\,]*$/g)){
                   e.target.value = e.target.value.slice(0, -1);
                    return false;
                }
                let replace = `[$₦€\,]+`;
                let re = new RegExp(replace,"g");
                e.target.value = currencyMap[beneficiaries?.find(item => item.beneficiaryId == values.beneficiary)?.currency || "ngn"] + convertToCurrency(e.target.value.replace(re, ''));
            }}
                     {...handleUpdate()} value={values.amount} fullWidth right={<img src={icons.money} alt="adornment"/>}/>
                </FormControl>
                <FormControl label="Remark (optional)"  name="remark" id="remark">
                    <InputWithAdornment {...handleUpdate()} value={values.remark}
                    fullWidth placeholder="Tell user what the money was for"/>
                </FormControl>
                <FormControl style={{marginTop:"12px"}}>
                    <Button onClick={() => onNext()} fullWidth> Continue </Button>
                </FormControl>
                
            </div>
        </div>
    )
}

export default SelectBeneficiary;